import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { externalLinks } from '../data/mock';
import { MessageCircle, Phone, Instagram, ExternalLink } from 'lucide-react';

const Contact = () => {
  const { language, t } = useLanguage();

  // Check if KakaoTalk URL exists
  const hasKakao = externalLinks.kakao && externalLinks.kakao.length > 0;

  return (
    <section className="bg-[#121212] py-16 md:py-24 animate-fade-in">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12">
          {t('contactTitle')}
        </h2>
        
        {/* Quick Contact Buttons */}
        <div className={`grid grid-cols-1 ${hasKakao ? 'md:grid-cols-3' : 'md:grid-cols-2'} gap-4`}>
          {/* KakaoTalk - only show if URL exists */}
          {hasKakao && (
            <a
              href={externalLinks.kakao}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center justify-center gap-3 p-8 bg-[#FEE500] text-black font-semibold transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-[#FEE500]/20"
              style={{ borderRadius: 0 }}
            >
              <MessageCircle size={32} />
              <span className="text-lg">{t('kakaoContact')}</span>
              <span className="text-sm opacity-70 flex items-center gap-1">
                {language === 'ko' ? '가장 빠른 답변' : 'Fastest Response'} <ExternalLink size={12} />
              </span>
            </a>
          )}
          
          {/* Phone */}
          <a
            href={externalLinks.phone}
            className="flex flex-col items-center justify-center gap-3 p-8 bg-[#00FFD1] text-black font-semibold transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-[#00FFD1]/20"
            style={{ borderRadius: 0 }}
          >
            <Phone size={32} />
            <span className="text-lg">{t('phoneContact')}</span>
            <span className="text-sm opacity-70">010-5446-8087</span>
          </a>
          
          {/* Instagram */}
          <a
            href={externalLinks.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center justify-center gap-3 p-8 bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 text-white font-semibold transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-pink-500/20"
            style={{ borderRadius: 0 }}
          >
            <Instagram size={32} />
            <span className="text-lg">{t('instaDM')}</span>
            <span className="text-sm opacity-70 flex items-center gap-1">
              @gangnamnoriteocoex <ExternalLink size={12} />
            </span>
          </a>
        </div>
        
        {/* Note */}
        <p className="text-center text-white/50 text-sm mt-8">
          {language === 'ko' 
            ? '인스타그램 DM 또는 전화로 문의해 주세요.' 
            : 'Contact us via Instagram DM or phone call.'}
        </p>
      </div>
    </section>
  );
};

export default Contact;
